import { BookingInfo } from '@models/booking-info.model';
import { IBookingModel } from '@services/api/booking/booking-model.interface';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BookingInfoService {
  constructor() {}

  /**
   * Create BookingInfo object from Booking model
   * @param booking Booking object from API
   * @returns BookingInfo object with properly formatted data
   */
  createBookingInfo(booking?: IBookingModel): BookingInfo {
    if (!booking || !booking.id) {
      // Return default booking info if no booking provided
      return new BookingInfo(0, 'Unknown Booking');
    }

    // Parse dates if they exist
    const startDate = booking.start_date ? new Date(booking.start_date) : undefined;
    const endDate = booking.end_date ? new Date(booking.end_date) : undefined;

    return new BookingInfo(booking.id, booking.name || 'Unnamed Booking', startDate, endDate);
  }
}
